// Account Page actions
import { createAction } from "typesafe-actions";
import * as types from "./types";

export const toggleUser = createAction(types.TOGGLE_USER, (uid: string) => ({
  uid
}))();
export const clearSelectedUsers = createAction(types.CLEAR_SELECTED_USERS)();
